import { FacilitySort } from '@gyym/sdk'

import { useFacilities } from '@/modules/Facilities'

import { useSearch } from './SearchProvider'

export const getSearchFacilitiesFetchPolicy = ({
  isMapView,
  isLocationResolved,
  sortBy,
}: {
  isMapView: boolean
  isLocationResolved: boolean
  sortBy: FacilitySort | undefined
}) => {
  const isDistanceSort = sortBy === FacilitySort.DISTANCE

  return {
    shouldFetch: !isMapView && (!isDistanceSort || isLocationResolved),
    revalidateOnMount: isDistanceSort,
  }
}

/**
 * 検索結果リストの取得。
 *
 * Content (件数表示) と RightContent (リスト本体) の両方から使うため、
 * ここで SWR キーとオプションを一元化する。キーがずれると同じ検索に対して
 * facilities.list が二重に走る (distance ソート時に実際に起きていた)。
 */
export const useSearchFacilities = () => {
  const {
    isMapView,
    isLocationResolved,
    searchParams,
    locatedSearchParams,
  } = useSearch()
  const { shouldFetch, revalidateOnMount } = getSearchFacilitiesFetchPolicy({
    isMapView,
    isLocationResolved,
    sortBy: searchParams.sortBy,
  })

  return useFacilities(
    locatedSearchParams,
    // distance ソートは geolocation の許可結果が確定してから、位置付きの
    // SWR キーを1度だけ取得する
    shouldFetch,
    {
      revalidateOnMount,
    },
  )
}
